<template>
  <section :class="isContactPage ? 'alt' : ''" class="content" id="content">
    <div class="inner">
      <div class="left">
        <div v-html="page && page.main_text"></div>

        <div v-if="isReviewsPage && reviews && reviews.length">
          <div :key="review._id" class="review" v-for="review in reviews">
            <p class="quote">
              <font-awesome-icon icon="quote-left" />
              {{ review.quote }}
              <font-awesome-icon icon="quote-right" />
            </p>
            <p class="label">{{ review.name }}</p>
          </div>
        </div>

        <div class="brochures" v-if="isPricesPage && brochures && brochures.length">
          <template v-for="brochure in brochures">
            <a :key="brochure._id" @click.prevent="showBrochure(brochure)" class="brochure">
              <img :alt="brochure.name" :key="brochure._id + '-img'" :src="brochure.image" />
              <span>{{ brochure.name }}</span>
            </a>
            <base-modal :key="brochure._id + 'modal'" :show="brochure._showModal" @close="$set(brochure, '_showModal', false)">
              <span :id="brochure._id"></span>
            </base-modal>
          </template>
        </div>
        <div id="downloads"></div>
        <div class="downloads" v-if="page.downloads && page.downloads.length">
          <h1>Price lists and Terms</h1>
          <a :key="download.id" :href="download.file" target="_blank" rel="noreferrer" class="download" v-for="download in page.downloads">
            <font-awesome-icon icon="file-download" /> <span>{{ download.name }}</span>
          </a>
        </div>
      </div>

      <div class="right" v-if="!isGalleryPage">
        <div class="images">
          <template v-for="(image, i) in page.images">
            <img :alt="image.alt" :key="image._id" :src="image.image" />
          </template>
        </div>
        <div class="links" v-if="page && page.siblings && page.siblings.length">
          <h3>More information</h3>
          <page-link :key="sibling.ItemID" :to="sibling.url" v-for="sibling in page.siblings">
            <font-awesome-icon icon="chevron-right" />
            {{ sibling.name }}
          </page-link>
        </div>
        <div class="links alt" v-if="page.downloads">
          <a href="#downloads"> <font-awesome-icon icon="chevron-right" /> Price list and Terms</a>
        </div>
        <iframe
          allowfullscreen
          frameborder="0"
          height="450"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9507.135387532375!2d-1.011095!3d53.436573!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x35c301ca8b966e52!2sW.E+Pinder+%26+Son+Ltd!5e0!3m2!1sen!2suk!4v1481817633697"
          style="border:0"
          v-if="isContactPage"
          width="100%"
        ></iframe>
      </div>

      <div class="gallery" v-if="isGalleryPage">
        <template v-for="image in page.images">
          <a :key="image._id" :style="'background-image:url(' + image.image + ')'" :title="image.alt" @click.prevent="$set(image, '_showModal', true)" href></a>
          <base-modal :key="image._id + 'modal'" :show="image._showModal" @close="$set(image, '_showModal', false)">
            <img :alt="image.alt" :src="image.image" class="zoom" />
            <span class="caption">{{ image.alt }}</span>
          </base-modal>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from "vuex"

export default {
  computed: {
    ...mapGetters(["isReviewsPage", "isPricesPage", "isGalleryPage", "isContactPage"]),
    ...mapState(["page", "reviews", "brochures"])
  },
  methods: {
    showBrochure(brochure) {
      this.$set(brochure, "_showModal", true)
      this.$nextTick().then(() => {
        document.getElementById(brochure._id).innerHTML = brochure.embed_code
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  padding: 4rem 0;
  line-height: 1.8;
  font-size: 1.8rem;
}

.content >>> h1 {
  color: #53453c;
  font-weight: normal;
  font-size: 3rem;
}

.content >>> h2 {
  padding-top: 2rem;
  color: #53453c;
  font-size: 2.2rem;
}

.content >>> ul,
.content >>> ol {
  padding-left: 3rem;
}

.gallery {
  clear: both;
}

.gallery a {
  width: 18%;
  margin-right: 2%;
  margin-bottom: 2rem;
  overflow: hidden;
  display: inline-block;
  height: 25rem;
  background-position: center center;
  background-size: cover;
  transition: all 0.3s;
}

.gallery a:hover {
  filter: brightness(1.1);
  transform: scale(1.05);
}

.zoom {
  display: block;
  margin: auto;
}

.caption {
  color: white;
  display: block;
  text-align: center;
}

.buy a {
  display: block;
  background: #af233e;
  color: white;
  padding: 1rem 2rem;
  margin-top: 1rem;
  margin-bottom: 3rem;
}

.buy a svg {
  float: right;
  position: relative;
  bottom: -0.5rem;
}

.links {
  background: #f7f7f7;
  padding-bottom: 2rem;
}

.links.alt {
  background: #53453c;
  color: white;
  padding: 0;
  margin-top: 3rem;
}

.links a {
  display: block;
  margin: 0 2.5rem;
  margin-top: 1rem;
}

.links.alt a {
  margin: 0;
  padding: 1rem 2.5rem;
}

.links h3 {
  background: #53453c;
  color: #fff;
  padding: 1rem 2.5rem;
  margin-bottom: 2rem;
  font-weight: normal;
}

.links a svg {
  margin-right: 1rem;
  color: #ccb198;
}

.left {
  width: 65%;
  float: left;
  margin-right: 5%;
  margin-bottom: 3rem;
}

.right {
  width: 30%;
  float: right;
}

.alt .left,
.alt .right {
  width: 47.5%;
}

.quote svg {
  color: #ccb198;
}

.quote svg:first-child {
  margin-right: 0.5rem;
}

.quote svg:last-child {
  margin-left: 0.5rem;
}

.label {
  color: #53453c;
  font-weight: bold;
  padding-top: 0rem;
}

.brochures {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 4rem;
  line-height: 1.2;
  margin-top: 4rem;
}

.brochure {
  cursor: pointer;
}

.brochure img {
  margin-bottom: 1rem;
  border: 1px solid #f5f5f5;
}
.downloads {
  margin-top: 3rem;
}

.download {
  display: block;
  padding: 1rem 2rem;
  background: #f7f7f7;
  margin-top: 1rem;
}
.download svg {
  color: #53453c;
  margin-right: 1rem;
}
.download:hover {
  background: #ccb198;
  color: white;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .brochures > div {
    width: 31%;
    margin-right: 2%;
  }
}

@media screen and (max-width: 780px) {
  .left,
  .right {
    width: 100% !important;
    margin-right: 0 !important;
  }

  .right {
    margin-bottom: 3rem;
  }

  .gallery a {
    width: 31.3%;
    height: 25rem;
  }
}

@media screen and (max-width: 500px) {
  .brochures {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
